import React, { type FC } from "react"
import Sponsors from "@components/Sponsors"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

const StrapiSponsors: FC<Queries.StrapiComponentSectionsSponsors> = ({
    content,
    content_images: contentImages,
    partners,
    additional_partners: additionalPartners
}) => {
    return <Sponsors
        content={parseContentImages(
            content,
            contentImages as unknown as ParseContentImagesProps[]
        )}
        partners={partners}
        additionalPartners={additionalPartners}
    />
}

export default StrapiSponsors
